import { render, staticRenderFns } from "./DemoSpecific.vue?vue&type=template&id=4056c137&scoped=true&"
import script from "./DemoSpecific.vue?vue&type=script&lang=js&"
export * from "./DemoSpecific.vue?vue&type=script&lang=js&"
import style0 from "./DemoSpecific.vue?vue&type=style&index=0&id=4056c137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4056c137",
  null
  
)

export default component.exports